<!--
 * @Author       : Tom
 * @Date         : 2019-12-16 11:34:38
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-20 20:12:21
 * @FilePath     : /shop_front_end/src/views/order_manage/index.vue
 * @Description  : 订单管理
 -->
<template>
	<div class="fund_manage">
		<a-tabs :defaultActiveKey="tabs" @change="onTabsCallback">
			<!-- <span slot="tabBarExtraContent">
				<a-button type="primary" class="freight" @click="onConfig">运费设置</a-button>
			</span> -->

			<a-tab-pane tab="全部订单" key="">
				<div style="flex: 1;display: flex;flex-direction: column;">
					<!-- 搜索 -->
					<div class="search">
						<a-form :form="form2" layout="inline" @submit="handleSubmit">
							<a-form-item>
								<a-input placeholder="请输入订单编号/姓名/电话/会员ID" v-decorator="['sNo']" style="width:260px;">
								</a-input>
							</a-form-item>

							<a-form-item v-show="tabs != '4'">
								<a-select allowClear style="width: 195px" v-decorator="['otype']" placeholder="请选择订单类型">
									<a-select-option v-for="(item, i) in ordertype" :key="i" :value="item.value">
										{{ item.name }}
									</a-select-option>
								</a-select>
							</a-form-item>
							<a-form-item v-show="tabs != '4'">
								<a-select allowClear style="width: 195px" v-decorator="['operation_type']"
									placeholder="请选择下单类型">
									<a-select-option value="1">
										用户下单
									</a-select-option>
									<a-select-option value="2">
										店铺下单
									</a-select-option>
									<a-select-option value="3">
										平台下单
									</a-select-option>
								</a-select>
							</a-form-item>
							<a-form-item v-show="tabs == '4'">
								<a-select allowClear style="width: 195px" v-decorator="['r_type']"
									placeholder="请选择订单状态">
									<a-select-option value="0">待审核</a-select-option>
									<a-select-option value="1">退款中</a-select-option>
									<a-select-option value="2">退款成功</a-select-option>
									<a-select-option value="3">退款失败</a-select-option>
									<a-select-option value="4">换货中</a-select-option>
									<a-select-option value="5">换货成功</a-select-option>
									<a-select-option value="6">换货失败</a-select-option>
								</a-select>
							</a-form-item>

							<a-form-item v-show="tabs == ''">
								<a-select allowClear style="width: 195px" v-decorator="['status']"
									placeholder="请选择订单状态">
									<a-select-option value="0">待付款</a-select-option>
									<a-select-option value="1">待发货</a-select-option>
									<a-select-option value="2">待收货</a-select-option>
									<a-select-option value="5">交易完成</a-select-option>
									<a-select-option value="7">交易关闭</a-select-option>
								</a-select>
							</a-form-item>

							<a-form-item>
								<a-range-picker v-decorator="['date']" :placeholder="['请选择开始时间', '请选择结束时间']" />
							</a-form-item>

							<a-form-item>
								<a-button @click="handleReset">重置</a-button>
							</a-form-item>

							<a-form-item>
								<a-button type="primary" html-type="submit">查询</a-button>
							</a-form-item>
						</a-form>
					</div>

					<!-- 操作栏 -->
					<div class="handle">
						<a-button type="primary" @click="$router.push({path: 'ordermanage/ValetOrder'})">代客下单</a-button>
						<a-divider type="vertical" />
						<a-button v-if="tabs != 1 && tabs != 4" @click="onBatchDel">批量删除
						</a-button>

						<a-divider v-if="tabs != 1 && tabs != 4" type="vertical" />

						<!-- <a-button @click="onOpenDeliver" v-if="tabs == 1">批量发货</a-button> -->

						<!-- <a-divider v-if="tabs == 1" type="vertical" /> -->
						<a-button @click="download()">导出</a-button>

						<a-divider v-if="tabs != 1 && tabs != 4" type="vertical" />

						<a-button type="primary" v-if="tabs != 1 && tabs != 4" @click="onBatchPrint">打印
						</a-button>
					</div>

					<!-- 表格 -->

					<div id="tableHeight">
						<a-table class="orderBox" v-show="tabs != '4' && tableHeight>0" ref="alltable" rowKey="sNo"
							:columns="columns" :data-source="orderlist" :pagination="pagination" @change="onChangess"
							:loading="config.load" :scroll="{ x: 1765,y: tableHeight }" :row-selection="rowSelection">
							<span slot="status" slot-scope="text,record">
								<span class="bold">{{ record.status }}</span>
							</span>
							<span slot="self_lifting" slot-scope="text,record">
								<span v-if="record.otype != 'VI'">{{ record.self_lifting == 1 ? '自提' : '快递' }}</span>
							</span>

							<span slot="operation_type" slot-scope="text,record">
								<span v-if="record.operation_type == '1'">用户下单</span>
								<span v-if="record.operation_type == '2'">店铺下单</span>
								<span v-if="record.operation_type == '3'">平台下单</span>
							</span>

							<span slot="goods_info" slot-scope="text,record">
								<div class="order_sNo">
									订单编号：{{ record.sNo }}
									<span></span>
									创单时间：{{ record.add_time }}
								</div>

								<div class="goods_info">
									<img :src="record.products[0].imgurl" />
									<div class="goods_info_right">
										<div class="bold" :title="record.products[0].product_title"
											style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 270px;">
											{{ record.products[0].product_title }}
										</div>

										<div
											style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 270px;">
											规格：{{ record.products[0].size }}
										</div>
										<div>
											数量：{{ record.products[0].num }}{{ record.products[0].unit }}
										</div>
										<div>
											小计：
											<template v-if="record.otype == 'KJ' || record.otype == 'JP'">
												{{ record.z_price }}
											</template>
											<template v-else>
												{{ record.products[0].num * record.products[0].p_price }}
											</template>

											元
										</div>
									</div>
								</div>
							</span>

							<span slot="z_price" slot-scope="text, record">
								￥{{ record.z_price }}
							</span>

							<span slot="order_type" slot-scope="text, record">
								<!--		      {{ order_type(record) }}-->
								{{ text }}
							</span>

							<span slot="buyer_info" slot-scope="text, record">
								<div class="buyer_info">
									<div>会员ID：{{ record.user_id || "暂无" }}</div>
									<div
										style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 180px;">
										联系人：{{ record.name || "暂无" }}
									</div>
									<div>电 话：{{ record.mobile || "暂无" }}</div>
									<div
										style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 180px;">
										地 址：{{
                record.address
                    ? record.sheng + record.shi + record.xian + record.address
                    : "暂无"
              }}
									</div>
								</div>
							</span>

							<span slot="logistics_info" slot-scope="text, record">
								<div class="logistics_info">
									<template v-if="record.courier_num.length">
										<div v-for="(item, i) in record.courier_num" :key="i">
											物流单号：{{ item }}
										</div>
									</template>

									<template v-else>
										<div>物流单号：暂无</div>
									</template>

									<div>运费：{{ record.freight || "免邮" }}</div>
								</div>
							</span>

							<span slot="action" slot-scope="text, record">
								<div class="action">
									<template v-if="record.self_lifting == 1">
										<div>
											<a @click="onViewDetails(record.sNo)">详情</a>
											<template v-if="record.statu == 1 || record.statu == 2">
												<a-divider type="vertical" />
												<a @click="openHexiao(record.id)">核销</a>
											</template>
										</div>
									</template>
									<template v-else>
										<!-- 待发货 | 赠送中 -->
										<template v-if="record.statu == 1">
											<template v-if="record.status === '待发货'">
												<div>
													<a @click="
					  			  $router.push({
					  			    path: 'ordermanage/editor/' + record.sNo,
					  			  })
					  			">编辑</a>
													<a-divider type="vertical" />
													<a @click="
					  			  $router.push({
					  			    path: 'ordermanage/deliver/' + record.sNo,
					  			  })
					  			">发货</a>
												</div>
											</template>
											<template v-else>
												<a @click="onViewDetails(record.sNo)">详情</a>
											</template>
										</template>

										<!-- 待发货 | 赠送中 -->
										<template v-if="
					      record.statu == 4 ||
					        record.statu == 7 ||
					        record.statu == 8 ||
					        record.statu == 9
					    ">
											<a @click="onViewDetails(record.sNo)">详情</a>
										</template>

										<!-- 关闭订单 -->
										<template v-if="record.statu == 6">
											<div>
												<a @click="onViewDetails(record.sNo)">详情</a>
												<a-divider type="vertical" />
												<a @click="onDeleteOrder(record)">删除</a>
											</div>
										</template>

										<!--  -->
										<template v-if="record.statu == 5">
											<div>
												<a @click="onViewDetails(record.sNo)">详情</a>
												<a-divider type="vertical" v-if="record.otype != 'VI'" />
												<a v-if="record.otype != 'VI'" @click="onOpenDodal(record)">物流</a>
											</div>
										</template>

										<!-- 待收货 -->
										<template v-if="record.statu == 2">
											<div>
												<a @click="onOpenDodal(record)">物流</a>
												<a-divider type="vertical" />
												<a @click="onViewDetails(record.sNo)">详情</a>
											</div>
										</template>

										<!-- 待付款 -->
										<template v-if="record.statu == 0">
											<div>
												<a @click="$router.push({
					  			path: 'ordermanage/editor/' + record.sNo,
					  		  })">编辑</a>
												<a-divider type="vertical" />
												<a @click="onOrderClose(record.sNo)">关闭</a>
											</div>
										</template>

										<!-- 带评价 -->
										<template v-if="record.statu == 3">
											<a @click="onViewDetails(record.sNo)">详情</a>
										</template>

									</template>
								</div>
							</span>
						</a-table>

						<a-table ref="alltable4" v-show="tabs == '4' && tableHeight>0" :dataSource="orderlist"
							:columns="columnsA" :pagination="pagination" @change="onChangess" :loading="config.load"
							:scroll="tableScroll">
							<span slot="tabNowrap" slot-scope="text, record">{{
            getTabNowrap(record)
          }}</span>

							<span slot="reType" slot-scope="text, record">{{
                  getReType(record)
                }}</span>

							<span slot="action" slot-scope="text, record">
								<a-button size="small" v-if="record.r_type == 0"
									@click="returnBtn(1, record.id, record)">审核
								</a-button>

								<!-- 退货退款收到客户寄来的货物后同意退款 -->
								<a-button size="small" v-if="record.r_type == 3 && record.re_type != 3"
									@click="returnBtn(2, record.id, record)">退款</a-button>

								<a-button size="small" v-if="record.r_type == 3 && record.re_type == 3"
									@click="returnBtn(3, record.id, record)">回寄</a-button>

								<!-- 收到客户寄来的货物后拒绝退款或退货 -->
								<a-button size="small" v-if="record.r_type == 3"
									@click="returnBtn(4, record.id, record)">拒绝
								</a-button>

								<a-button size="small" v-if="record.r_type != 0"
									@click="returnBtn(5, record.id, record)">查看
								</a-button>
							</span>
						</a-table>
					</div>

				</div>
			</a-tab-pane>
			<a-tab-pane tab="待付款" key="0">
				<div style="flex: 1;display: flex;flex-direction: column;">
					<!-- 搜索 -->
					<div class="search">
						<a-form :form="form2" layout="inline" @submit="handleSubmit">
							<a-form-item>
								<a-input placeholder="请输入订单编号/姓名/电话/会员ID" v-decorator="['sNo']" style="width:260px;">
								</a-input>
							</a-form-item>

							<a-form-item v-show="tabs != '4'">
								<a-select allowClear style="width: 195px" v-decorator="['otype']" placeholder="请选择订单类型">
									<a-select-option v-for="(item, i) in ordertype" :key="i" :value="item.value">
										{{ item.name }}
									</a-select-option>
								</a-select>
							</a-form-item>
							<a-form-item v-show="tabs == '4'">
								<a-select allowClear style="width: 195px" v-decorator="['r_type']"
									placeholder="请选择订单状态">
									<a-select-option value="0">待审核</a-select-option>
									<a-select-option value="1">退款中</a-select-option>
									<a-select-option value="2">退款成功</a-select-option>
									<a-select-option value="3">退款失败</a-select-option>
									<a-select-option value="4">换货中</a-select-option>
									<a-select-option value="5">换货成功</a-select-option>
									<a-select-option value="6">换货失败</a-select-option>
								</a-select>
							</a-form-item>

							<a-form-item v-show="tabs == ''">
								<a-select allowClear style="width: 195px" v-decorator="['status']"
									placeholder="请选择订单状态">
									<a-select-option value="0">待付款</a-select-option>
									<a-select-option value="1">待发货</a-select-option>
									<a-select-option value="2">待收货</a-select-option>
									<a-select-option value="5">交易完成</a-select-option>
									<a-select-option value="7">交易关闭</a-select-option>
								</a-select>
							</a-form-item>

							<a-form-item>
								<a-range-picker v-decorator="['date']" :placeholder="['请选择开始时间', '请选择结束时间']" />
							</a-form-item>

							<a-form-item>
								<a-button @click="handleReset">重置</a-button>
							</a-form-item>

							<a-form-item>
								<a-button type="primary" html-type="submit">查询
								</a-button>
							</a-form-item>
						</a-form>
					</div>

					<!-- 操作栏 -->
					<div class="handle">
						<a-button v-if="tabs != 1 && tabs != 4" @click="onBatchDel">批量删除
						</a-button>

						<a-divider v-if="tabs != 1 && tabs != 4" type="vertical" />

						<!-- <a-button @click="onOpenDeliver" v-if="tabs == 1">批量发货</a-button> -->

						<!-- <a-divider v-if="tabs == 1" type="vertical" /> -->
						<a-button @click="download()">导出</a-button>

						<a-divider v-if="tabs != 1 && tabs != 4" type="vertical" />

						<a-button type="primary" v-if="tabs != 1 && tabs != 4" @click="onBatchPrint">打印
						</a-button>
					</div>

					<!-- 表格 -->

					<div id="tableHeight">
						<a-table class="orderBox" v-show="tabs != '4' && tableHeight>0" ref="alltable" rowKey="sNo"
							:columns="columns" :data-source="orderlist" :pagination="pagination" @change="onChangess"
							:loading="config.load" :scroll="{ x: 1765,y: tableHeight }" :row-selection="rowSelection">
							<span slot="status" slot-scope="text,record">
								<span class="bold">{{ record.status }}</span>
							</span>
							<span slot="self_lifting" slot-scope="text,record">
								<span>{{ record.self_lifting == 1 ? '自提' : '快递' }}</span>
							</span>

							<span slot="goods_info" slot-scope="text,record">
								<div class="order_sNo">
									订单编号：{{ record.sNo }}
									<span></span>
									创单时间：{{ record.add_time }}
								</div>

								<div class="goods_info">
									<img :src="record.products[0].imgurl" />
									<div class="goods_info_right">
										<div class="bold" :title="record.products[0].product_title"
											style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 270px;">
											{{ record.products[0].product_title }}
										</div>

										<div
											style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 270px;">
											规格：{{ record.products[0].size }}
										</div>
										<div>
											数量：{{ record.products[0].num }}{{ record.products[0].unit }}
										</div>
										<div>
											小计：
											<template v-if="record.otype == 'KJ' || record.otype == 'JP'">
												{{ record.z_price }}
											</template>
											<template v-else>
												{{ record.products[0].num * record.products[0].p_price }}
											</template>

											元
										</div>
									</div>
								</div>
							</span>

							<span slot="z_price" slot-scope="text, record">
								￥{{ record.z_price }}
							</span>

							<span slot="order_type" slot-scope="text, record">
								{{ order_type(record) }}
							</span>

							<span slot="buyer_info" slot-scope="text, record">
								<div class="buyer_info">
									<div>会员ID：{{ record.user_id || "暂无" }}</div>
									<div
										style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 180px;">
										联系人：{{ record.name || "暂无" }}
									</div>
									<div>电 话：{{ record.mobile || "暂无" }}</div>
									<div
										style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 180px;">
										地 址：{{
                record.address
                    ? record.sheng + record.shi + record.xian + record.address
                    : "暂无"
              }}
									</div>
								</div>
							</span>

							<span slot="logistics_info" slot-scope="text, record">
								<div class="logistics_info">
									<template v-if="record.courier_num.length">
										<div v-for="(item, i) in record.courier_num" :key="i">
											物流单号：{{ item }}
										</div>
									</template>

									<template v-else>
										<div>物流单号：暂无</div>
									</template>

									<div>运费：{{ record.freight || "免邮" }}</div>
								</div>
							</span>

							<span slot="action" slot-scope="text, record">
								<div class="action">
									<template v-if="record.self_lifting == 1">
										<div>
											<a @click="onViewDetails(record.sNo)">详情</a>
											<template v-if="record.statu == 1 || record.statu == 2">
												<a-divider type="vertical" />
												<a @click="openHexiao(record.id)">核销</a>
											</template>
										</div>
									</template>
									<template v-else>
										<!-- 待发货 | 赠送中 -->
										<template v-if="record.statu == 1">
											<template v-if="record.status === '待发货'">
												<div>
													<a @click="
		  					  			  $router.push({
		  					  			    path: 'ordermanage/editor/' + record.sNo,
		  					  			  })
		  					  			">编辑</a>
													<a-divider type="vertical" />
													<a @click="
		  					  			  $router.push({
		  					  			    path: 'ordermanage/deliver/' + record.sNo,
		  					  			  })
		  					  			">发货</a>
												</div>
											</template>
											<template v-else>
												<a @click="onViewDetails(record.sNo)">详情</a>
											</template>
										</template>

										<!-- 待发货 | 赠送中 -->
										<template v-if="
		  					      record.statu == 4 ||
		  					        record.statu == 7 ||
		  					        record.statu == 8 ||
		  					        record.statu == 9
		  					    ">
											<a @click="onViewDetails(record.sNo)">详情</a>
										</template>

										<!-- 关闭订单 -->
										<template v-if="record.statu == 6">
											<div>
												<a @click="onViewDetails(record.sNo)">详情</a>
												<a-divider type="vertical" />
												<a @click="onDeleteOrder(record)">删除</a>
											</div>
										</template>

										<!--  -->
										<template v-if="record.statu == 5">
											<div>
												<a @click="onViewDetails(record.sNo)">详情</a>
												<a-divider type="vertical" />
												<a @click="onOpenDodal(record)">物流</a>
											</div>
										</template>

										<!-- 待收货 -->
										<template v-if="record.statu == 2">
											<div>
												<a @click="onOpenDodal(record)">物流</a>
												<a-divider type="vertical" />
												<a @click="onViewDetails(record.sNo)">详情</a>
											</div>
										</template>

										<!-- 待付款 -->
										<template v-if="record.statu == 0">
											<div>
												<a @click="$router.push({
		  					  			path: 'ordermanage/editor/' + record.sNo,
		  					  		  })">编辑</a>
												<a-divider type="vertical" />
												<a @click="onOrderClose(record.sNo)">关闭</a>
											</div>
										</template>

										<!-- 带评价 -->
										<template v-if="record.statu == 3">
											<a @click="onViewDetails(record.sNo)">详情</a>
										</template>

									</template>
								</div>
							</span>
						</a-table>

						<a-table ref="alltable4" v-show="tabs == '4' && tableHeight>0" :dataSource="orderlist"
							:columns="columnsA" :pagination="pagination" @change="onChangess" :loading="config.load"
							:scroll="tableScroll">
							<span slot="tabNowrap" slot-scope="text, record">{{
            getTabNowrap(record)
          }}</span>

							<span slot="reType" slot-scope="text, record">{{
                  getReType(record)
                }}</span>

							<span slot="action" slot-scope="text, record">
								<a-button size="small" v-if="record.r_type == 0"
									@click="returnBtn(1, record.id, record)">审核
								</a-button>

								<!-- 退货退款收到客户寄来的货物后同意退款 -->
								<a-button size="small" v-if="record.r_type == 3 && record.re_type != 3"
									@click="returnBtn(2, record.id, record)">退款</a-button>

								<a-button size="small" v-if="record.r_type == 3 && record.re_type == 3"
									@click="returnBtn(3, record.id, record)">回寄</a-button>

								<!-- 收到客户寄来的货物后拒绝退款或退货 -->
								<a-button size="small" v-if="record.r_type == 3"
									@click="returnBtn(4, record.id, record)">拒绝
								</a-button>

								<a-button size="small" v-if="record.r_type != 0"
									@click="returnBtn(5, record.id, record)">查看
								</a-button>
							</span>
						</a-table>
					</div>

				</div>
			</a-tab-pane>
			<a-tab-pane tab="待发货" key="1">
				<div style="flex: 1;display: flex;flex-direction: column;">
					<!-- 搜索 -->
					<div class="search">
						<a-form :form="form2" layout="inline" @submit="handleSubmit">
							<a-form-item>
								<a-input placeholder="请输入订单编号/姓名/电话/会员ID" v-decorator="['sNo']" style="width:260px;">
								</a-input>
							</a-form-item>

							<a-form-item v-show="tabs != '4'">
								<a-select allowClear style="width: 195px" v-decorator="['otype']" placeholder="请选择订单类型">
									<a-select-option v-for="(item, i) in ordertype" :key="i" :value="item.value">
										{{ item.name }}
									</a-select-option>
								</a-select>
							</a-form-item>
							<a-form-item v-show="tabs == '4'">
								<a-select allowClear style="width: 195px" v-decorator="['r_type']"
									placeholder="请选择订单状态">
									<a-select-option value="0">待审核</a-select-option>
									<a-select-option value="1">退款中</a-select-option>
									<a-select-option value="2">退款成功</a-select-option>
									<a-select-option value="3">退款失败</a-select-option>
									<a-select-option value="4">换货中</a-select-option>
									<a-select-option value="5">换货成功</a-select-option>
									<a-select-option value="6">换货失败</a-select-option>
								</a-select>
							</a-form-item>

							<a-form-item v-show="tabs == ''">
								<a-select allowClear style="width: 195px" v-decorator="['status']"
									placeholder="请选择订单状态">
									<a-select-option value="0">待付款</a-select-option>
									<a-select-option value="1">待发货</a-select-option>
									<a-select-option value="2">待收货</a-select-option>
									<a-select-option value="5">交易完成</a-select-option>
									<a-select-option value="7">交易关闭</a-select-option>
								</a-select>
							</a-form-item>

							<a-form-item>
								<a-range-picker v-decorator="['date']" :placeholder="['请选择开始时间', '请选择结束时间']" />
							</a-form-item>

							<a-form-item>
								<a-button @click="handleReset">重置</a-button>
							</a-form-item>

							<a-form-item>
								<a-button type="primary" html-type="submit">查询
								</a-button>
							</a-form-item>
						</a-form>
					</div>

					<!-- 操作栏 -->
					<div class="handle">
						<a-button v-if="tabs != 1 && tabs != 4" @click="onBatchDel">批量删除
						</a-button>

						<a-divider v-if="tabs != 1 && tabs != 4" type="vertical" />

						<!-- <a-button @click="onOpenDeliver" v-if="tabs == 1">批量发货</a-button> -->

						<!-- <a-divider v-if="tabs == 1" type="vertical" /> -->
						<a-button @click="download()">导出</a-button>

						<a-divider v-if="tabs != 1 && tabs != 4" type="vertical" />

						<a-button type="primary" v-if="tabs != 1 && tabs != 4" @click="onBatchPrint">打印
						</a-button>
					</div>

					<!-- 表格 -->

					<div id="tableHeight">
						<a-table class="orderBox" v-show="tabs != '4' && tableHeight>0" ref="alltable" rowKey="sNo"
							:columns="columns" :data-source="orderlist" :pagination="pagination" @change="onChangess"
							:loading="config.load" :scroll="{ x: 1765,y: tableHeight }" :row-selection="rowSelection">
							<span slot="status" slot-scope="text,record">
								<span class="bold">{{ record.status }}</span>
							</span>
							<span slot="self_lifting" slot-scope="text,record">
								<span>{{ record.self_lifting == 1 ? '自提' : '快递' }}</span>
							</span>

							<span slot="goods_info" slot-scope="text,record">
								<div class="order_sNo">
									订单编号：{{ record.sNo }}
									<span></span>
									创单时间：{{ record.add_time }}
								</div>

								<div class="goods_info">
									<img :src="record.products[0].imgurl" />
									<div class="goods_info_right">
										<div class="bold" :title="record.products[0].product_title"
											style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 270px;">
											{{ record.products[0].product_title }}
										</div>

										<div
											style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 270px;">
											规格：{{ record.products[0].size }}
										</div>
										<div>
											数量：{{ record.products[0].num }}{{ record.products[0].unit }}
										</div>
										<div>
											小计：
											<template v-if="record.otype == 'KJ' || record.otype == 'JP'">
												{{ record.z_price }}
											</template>
											<template v-else>
												{{ record.products[0].num * record.products[0].p_price }}
											</template>

											元
										</div>
									</div>
								</div>
							</span>

							<span slot="z_price" slot-scope="text, record">
								￥{{ record.z_price }}
							</span>

							<span slot="order_type" slot-scope="text, record">
								{{ order_type(record) }}
							</span>

							<span slot="buyer_info" slot-scope="text, record">
								<div class="buyer_info">
									<div>会员ID：{{ record.user_id || "暂无" }}</div>
									<div
										style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 180px;">
										联系人：{{ record.name || "暂无" }}
									</div>
									<div>电 话：{{ record.mobile || "暂无" }}</div>
									<div
										style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 180px;">
										地 址：{{
                record.address
                    ? record.sheng + record.shi + record.xian + record.address
                    : "暂无"
              }}
									</div>
								</div>
							</span>

							<span slot="logistics_info" slot-scope="text, record">
								<div class="logistics_info">
									<template v-if="record.courier_num.length">
										<div v-for="(item, i) in record.courier_num" :key="i">
											物流单号：{{ item }}
										</div>
									</template>

									<template v-else>
										<div>物流单号：暂无</div>
									</template>

									<div>运费：{{ record.freight || "免邮" }}</div>
								</div>
							</span>

							<span slot="action" slot-scope="text, record">
								<div class="action">
									<template v-if="record.self_lifting == 1">
										<div>
											<a @click="onViewDetails(record.sNo)">详情</a>
											<template v-if="record.statu == 1 || record.statu == 2">
												<a-divider type="vertical" />
												<a @click="openHexiao(record.id)">核销</a>
											</template>
										</div>
									</template>
									<template v-else>
										<!-- 待发货 | 赠送中 -->
										<template v-if="record.statu == 1">
											<template v-if="record.status === '待发货'">
												<div>
													<a @click="
		  					  			  $router.push({
		  					  			    path: 'ordermanage/editor/' + record.sNo,
		  					  			  })
		  					  			">编辑</a>
													<a-divider type="vertical" />
													<a @click="
		  					  			  $router.push({
		  					  			    path: 'ordermanage/deliver/' + record.sNo,
		  					  			  })
		  					  			">发货</a>
												</div>
											</template>
											<template v-else>
												<a @click="onViewDetails(record.sNo)">详情</a>
											</template>
										</template>

										<!-- 待发货 | 赠送中 -->
										<template v-if="
		  					      record.statu == 4 ||
		  					        record.statu == 7 ||
		  					        record.statu == 8 ||
		  					        record.statu == 9
		  					    ">
											<a @click="onViewDetails(record.sNo)">详情</a>
										</template>

										<!-- 关闭订单 -->
										<template v-if="record.statu == 6">
											<div>
												<a @click="onViewDetails(record.sNo)">详情</a>
												<a-divider type="vertical" />
												<a @click="onDeleteOrder(record)">删除</a>
											</div>
										</template>

										<!--  -->
										<template v-if="record.statu == 5">
											<div>
												<a @click="onViewDetails(record.sNo)">详情</a>
												<a-divider type="vertical" />
												<a @click="onOpenDodal(record)">物流</a>
											</div>
										</template>

										<!-- 待收货 -->
										<template v-if="record.statu == 2">
											<div>
												<a @click="onOpenDodal(record)">物流</a>
												<a-divider type="vertical" />
												<a @click="onViewDetails(record.sNo)">详情</a>
											</div>
										</template>

										<!-- 待付款 -->
										<template v-if="record.statu == 0">
											<div>
												<a @click="$router.push({
		  					  			path: 'ordermanage/editor/' + record.sNo,
		  					  		  })">编辑</a>
												<a-divider type="vertical" />
												<a @click="onOrderClose(record.sNo)">关闭</a>
											</div>
										</template>

										<!-- 带评价 -->
										<template v-if="record.statu == 3">
											<a @click="onViewDetails(record.sNo)">详情</a>
										</template>

									</template>
								</div>
							</span>
						</a-table>

						<a-table ref="alltable4" v-show="tabs == '4' && tableHeight>0" :dataSource="orderlist"
							:columns="columnsA" :pagination="pagination" @change="onChangess" :loading="config.load"
							:scroll="{ x: 1600,y: tableHeight }">
							<span slot="tabNowrap" slot-scope="text, record">{{
            getTabNowrap(record)
          }}</span>

							<span slot="reType" slot-scope="text, record">{{
                  getReType(record)
                }}</span>

							<span slot="action" slot-scope="text, record">
								<a-button size="small" v-if="record.r_type == 0"
									@click="returnBtn(1, record.id, record)">审核
								</a-button>

								<!-- 退货退款收到客户寄来的货物后同意退款 -->
								<a-button size="small" v-if="record.r_type == 3 && record.re_type != 3"
									@click="returnBtn(2, record.id, record)">退款</a-button>

								<a-button size="small" v-if="record.r_type == 3 && record.re_type == 3"
									@click="returnBtn(3, record.id, record)">回寄</a-button>

								<!-- 收到客户寄来的货物后拒绝退款或退货 -->
								<a-button size="small" v-if="record.r_type == 3"
									@click="returnBtn(4, record.id, record)">拒绝
								</a-button>

								<a-button size="small" v-if="record.r_type != 0"
									@click="returnBtn(5, record.id, record)">查看
								</a-button>
							</span>
						</a-table>
					</div>

				</div>
			</a-tab-pane>
			<a-tab-pane tab="退款" key="4">
				<div style="flex: 1;display: flex;flex-direction: column;">
					<!-- 搜索 -->
					<div class="search">
						<a-form :form="form2" layout="inline" @submit="handleSubmit">
							<a-form-item>
								<a-input placeholder="请输入订单编号/姓名/电话/会员ID" v-decorator="['sNo']" style="width:260px;">
								</a-input>
							</a-form-item>

							<a-form-item v-show="tabs != '4'">
								<a-select allowClear style="width: 195px" v-decorator="['otype']" placeholder="请选择订单类型">
									<a-select-option v-for="(item, i) in ordertype" :key="i" :value="item.value">
										{{ item.name }}
									</a-select-option>
								</a-select>
							</a-form-item>
							<a-form-item v-show="tabs == '4'">
								<a-select allowClear style="width: 195px" v-decorator="['r_type']"
									placeholder="请选择订单状态">
									<a-select-option value="0">待审核</a-select-option>
									<a-select-option value="1">退款中</a-select-option>
									<a-select-option value="2">退款成功</a-select-option>
									<a-select-option value="3">退款失败</a-select-option>
									<a-select-option value="4">换货中</a-select-option>
									<a-select-option value="5">换货成功</a-select-option>
									<a-select-option value="6">换货失败</a-select-option>
								</a-select>
							</a-form-item>

							<a-form-item v-show="tabs == ''">
								<a-select allowClear style="width: 195px" v-decorator="['status']"
									placeholder="请选择订单状态">
									<a-select-option value="0">待付款</a-select-option>
									<a-select-option value="1">待发货</a-select-option>
									<a-select-option value="2">待收货</a-select-option>
									<a-select-option value="5">交易完成</a-select-option>
									<a-select-option value="7">交易关闭</a-select-option>
								</a-select>
							</a-form-item>

							<a-form-item>
								<a-range-picker v-decorator="['date']" :placeholder="['请选择开始时间', '请选择结束时间']" />
							</a-form-item>

							<a-form-item>
								<a-button @click="handleReset">重置</a-button>
							</a-form-item>

							<a-form-item>
								<a-button type="primary" html-type="submit">查询
								</a-button>
							</a-form-item>
						</a-form>
					</div>

					<!-- 操作栏 -->
					<div class="handle">
						<a-button v-if="tabs != 1 && tabs != 4" @click="onBatchDel">批量删除
						</a-button>

						<a-divider v-if="tabs != 1 && tabs != 4" type="vertical" />

						<!-- <a-button @click="onOpenDeliver" v-if="tabs == 1">批量发货</a-button> -->

						<!-- <a-divider v-if="tabs == 1" type="vertical" /> -->
						<a-button @click="download()">导出</a-button>
					</div>

					<!-- 表格 -->

					<div id="tableHeight">
						<a-table class="orderBox" v-show="tabs != '4' && tableHeight>0" ref="alltable" rowKey="sNo"
							:columns="columns" :data-source="orderlist" :pagination="pagination" @change="onChangess"
							:loading="config.load" :scroll="{ x: 1765,y: tableHeight }" :row-selection="rowSelection">
							<span slot="status" slot-scope="text,record">
								<span class="bold">{{ record.status }}</span>
							</span>
							<span slot="self_lifting" slot-scope="text,record">
								<span>{{ record.self_lifting == 1 ? '自提' : '快递' }}</span>
							</span>

							<span slot="goods_info" slot-scope="text,record">
								<div class="order_sNo">
									订单编号：{{ record.sNo }}
									<span></span>
									创单时间：{{ record.add_time }}
								</div>

								<div class="goods_info">
									<img :src="record.products[0].imgurl" />
									<div class="goods_info_right">
										<div class="bold" :title="record.products[0].product_title"
											style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 270px;">
											{{ record.products[0].product_title }}
										</div>

										<div
											style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 270px;">
											规格：{{ record.products[0].size }}
										</div>
										<div>
											数量：{{ record.products[0].num }}{{ record.products[0].unit }}
										</div>
										<div>
											小计：
											<template v-if="record.otype == 'KJ' || record.otype == 'JP'">
												{{ record.z_price }}
											</template>
											<template v-else>
												{{ record.products[0].num * record.products[0].p_price }}
											</template>

											元
										</div>
									</div>
								</div>
							</span>

							<span slot="z_price" slot-scope="text, record">
								￥{{ record.z_price }}
							</span>

							<span slot="order_type" slot-scope="text, record">
								{{ order_type(record) }}
							</span>

							<span slot="buyer_info" slot-scope="text, record">
								<div class="buyer_info">
									<div>会员ID：{{ record.user_id || "暂无" }}</div>
									<div
										style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 180px;">
										联系人：{{ record.name || "暂无" }}
									</div>
									<div>电 话：{{ record.mobile || "暂无" }}</div>
									<div
										style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 180px;">
										地 址：{{
                record.address
                    ? record.sheng + record.shi + record.xian + record.address
                    : "暂无"
              }}
									</div>
								</div>
							</span>

							<span slot="logistics_info" slot-scope="text, record">
								<div class="logistics_info">
									<template v-if="record.courier_num.length">
										<div v-for="(item, i) in record.courier_num" :key="i">
											物流单号：{{ item }}
										</div>
									</template>

									<template v-else>
										<div>物流单号：暂无</div>
									</template>

									<div>运费：{{ record.freight || "免邮" }}</div>
								</div>
							</span>

							<span slot="action" slot-scope="text, record">
								<div class="action">
									<template v-if="record.self_lifting == 1">
										<div>
											<a @click="onViewDetails(record.sNo)">详情</a>
											<template v-if="record.statu == 1 || record.statu == 2">
												<a-divider type="vertical" />
												<a @click="openHexiao(record.id)">核销</a>
											</template>
										</div>
									</template>
									<template v-else>
										<!-- 待发货 | 赠送中 -->
										<template v-if="record.statu == 1">
											<template v-if="record.status === '待发货'">
												<div>
													<a @click="
		  					  			  $router.push({
		  					  			    path: 'ordermanage/editor/' + record.sNo,
		  					  			  })
		  					  			">编辑</a>
													<a-divider type="vertical" />
													<a @click="
		  					  			  $router.push({
		  					  			    path: 'ordermanage/deliver/' + record.sNo,
		  					  			  })
		  					  			">发货</a>
												</div>
											</template>
											<template v-else>
												<a @click="onViewDetails(record.sNo)">详情</a>
											</template>
										</template>

										<!-- 待发货 | 赠送中 -->
										<template v-if="
		  					      record.statu == 4 ||
		  					        record.statu == 7 ||
		  					        record.statu == 8 ||
		  					        record.statu == 9
		  					    ">
											<a @click="onViewDetails(record.sNo)">详情</a>
										</template>

										<!-- 关闭订单 -->
										<template v-if="record.statu == 6">
											<div>
												<a @click="onViewDetails(record.sNo)">详情</a>
												<a-divider type="vertical" />
												<a @click="onDeleteOrder(record)">删除</a>
											</div>
										</template>

										<!--  -->
										<template v-if="record.statu == 5">
											<div>
												<a @click="onViewDetails(record.sNo)">详情</a>
												<a-divider type="vertical" />
												<a @click="onOpenDodal(record)">物流</a>
											</div>
										</template>

										<!-- 待收货 -->
										<template v-if="record.statu == 2">
											<div>
												<a @click="onOpenDodal(record)">物流</a>
												<a-divider type="vertical" />
												<a @click="onViewDetails(record.sNo)">详情</a>
											</div>
										</template>

										<!-- 待付款 -->
										<template v-if="record.statu == 0">
											<div>
												<a @click="$router.push({
		  					  			path: 'ordermanage/editor/' + record.sNo,
		  					  		  })">编辑</a>
												<a-divider type="vertical" />
												<a @click="onOrderClose(record.sNo)">关闭</a>
											</div>
										</template>

										<!-- 带评价 -->
										<template v-if="record.statu == 3">
											<a @click="onViewDetails(record.sNo)">详情</a>
										</template>

									</template>
								</div>
							</span>
						</a-table>

						<a-table ref="alltable4" v-show="tabs == '4' && tableHeight>0" :dataSource="orderlist"
							:columns="columnsA" :pagination="pagination" @change="onChangess" :loading="config.load"
							:scroll="{ x: 1650,y: tableHeight }">
							<span slot="tabNowrap" slot-scope="text, record">{{
            getTabNowrap(record)
          }}</span>

							<span slot="reType" slot-scope="text, record">{{
                  getReType(record)
                }}</span>

							<span slot="action" slot-scope="text, record">
								<a-button size="small" v-if="record.r_type == 0"
									@click="returnBtn(1, record.id, record)">审核
								</a-button>

								<!-- 退货退款收到客户寄来的货物后同意退款 -->
								<a-button size="small" v-if="record.r_type == 3 && record.re_type != 3"
									@click="returnBtn(2, record.id, record)">退款</a-button>

								<a-button size="small" v-if="record.r_type == 3 && record.re_type == 3"
									@click="returnBtn(3, record.id, record)">回寄</a-button>

								<!-- 收到客户寄来的货物后拒绝退款或退货 -->
								<a-button size="small" v-if="record.r_type == 3"
									@click="returnBtn(4, record.id, record)">拒绝
								</a-button>

								<a-button size="small" v-if="record.r_type != 0"
									@click="returnBtn(5, record.id, record)">查看
								</a-button>
							</span>
						</a-table>
					</div>

				</div>
			</a-tab-pane>
		</a-tabs>


		<!-- 回寄商品 -->
		<a-modal v-model="returnVisible" title="回寄商品" :footer="null" width="540px">
			<a-form :form="form3">
				<a-form-item label="快递公司" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
					<a-select show-search placeholder="请选择快递公司" option-filter-prop="children" style="width: 295px"
						@change="handleChange" v-decorator="[
              'kuaidi_name',
              { rules: [{ required: true, message: '请选择快递公司!' }] },
            ]">
						<a-select-option v-for="(item, index) of kuaidi_list" :key="index" :value="item.id">
							{{ item.kuaidi_name }}
						</a-select-option>
					</a-select>
				</a-form-item>

				<a-form-item label="快递单号" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
					<a-input placeholder="请输入正确的快递单号" style="width: 295px;" v-decorator="[
              'kuaidi_sNo',
              {
                rules: [{ required: true, message: '请输入正确的快递单号!' }],
                initialValue: filepath,
              },
            ]"></a-input>
				</a-form-item>
				<div style="display:flex;justify-content: center;">
					<a-button @click="saveKuaidi">确认</a-button>
				</div>
			</a-form>
		</a-modal>

		<!-- 物流信息 -->
		<a-modal title="物流信息" v-model="visible" :footer="null" width="920px">
			<div class="logistics">
				<div v-for="(item, i) in logisticslist" :key="i">
					<div>
						<span>物流公司：</span>
						<span>{{ item.kuaidi_name }}</span>
					</div>

					<div>
						<span>运单号码：</span>
						<span>{{ item.courier_num }}</span>
					</div>

					<div class="logistics-box">
						<div>物流跟踪：</div>
						<div class="logistics-box-right">
							<a-timeline v-if="item.data.length">
								<a-timeline-item v-for="(items, b) in item.data" :key="b">
									<a-icon slot="dot" type="check-circle" style="font-size: 12px;" />
									<span class="times">{{ items.time }}</span>
									{{ items.context }}
								</a-timeline-item>
							</a-timeline>
							<a-empty v-else />
						</div>
					</div>
				</div>
				<!-- <a-empty v-if="logisticslist.length == 0" /> -->
			</div>
		</a-modal>

		<!-- 批量发货 -->
		<a-modal title="批量发货" v-model="modelbatch" width="540px" @ok="onDeliver" @cancel="closeDeliver"
			:confirmLoading="deliverLoading">
			<a-form :form="form">
				<a-form-item label="发货模版" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
					<a-button type="primary" ghost @click="templateDownload">点击下载
					</a-button>
				</a-form-item>

				<a-form-item label="导入发货文件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
					<a-input placeholder="请选择文件路径" style="width: 295px;" v-decorator="[
              'filename',
              {
                rules: [{ required: true, message: '请选择文件路径!' }],
                initialValue: filepath,
              },
            ]">
						<input type="file" slot="addonAfter" @change="onGetFile($event)" />
					</a-input>

					<div style="color:#969DA8;display:flex;align-items: baseline;">
						<div class="yuanquan">!</div>
						温馨提示：发货文件必须填写物流公司及物流编号！
					</div>
				</a-form-item>
			</a-form>
		</a-modal>

		<!-- 导出 -->
		<a-modal v-model="visible1" title="导出数据" :footer="null" width="540px">
			<div class="derive">
				<div @click="onDownload('This_page')">
					<a-icon type="file-text" style="font-size:26px;" />
					<div>导出本页</div>
				</div>

				<div @click="onDownload('whole')">
					<a-icon type="snippets" style="font-size:26px;" />
					<div>导出全部</div>
				</div>

				<div @click="onDownload('inquiry')">
					<a-icon type="file-search" style="font-size:26px;" />
					<div>导出查询</div>
				</div>
			</div>
		</a-modal>

		<!-- 拒绝 -->
		<a-modal v-model="jujueFlag" title="拒绝理由" :footer="null" width="540px">
			<a-form :form="jujueForm">
				<a-form-item label="拒绝理由" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
					<a-input placeholder="请输入拒绝理由" style="width: 295px;" v-decorator="[
              'text',
              { rules: [{ required: true, message: '请输入拒绝理由!' }] },
            ]"></a-input>
				</a-form-item>
				<div style="display:flex;justify-content: center;">
					<a-button @click="onGoBack">确认</a-button>
				</div>
			</a-form>
		</a-modal>

		<!-- 核销 -->
		<a-modal v-model="hexiaoFlag" title="核销" width="540px" @ok="hexiaoOk">
			<a-form :form="hexiaoForm">
				<a-form-item label="验证码" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
					<a-input placeholder="请输入提取验证码" v-decorator="[
              'hexiao',
              { rules: [{ required: true, message: '请输入提取验证码!' }] },
            ]"></a-input>
				</a-form-item>
			</a-form>

		</a-modal>
	</div>
</template>

<script>
	import OrderTable from "./OrderTable";

	const columnsA = [
		// {
		//   title: '序号'
		// },
		{
			title: "用户ID",
			key: "user_id",
			dataIndex: "user_id",
			width: 100,
			fixed: 'left'
		},
		{
			title: "产品名称",
			key: "p_name",
			dataIndex: "p_name",
			width: 220
		},
		{
			title: "店铺名称",
			key: "shop_name",
			dataIndex: "shop_name",
			width: 150
		},
		{
			title: "产品价格",
			key: "p_price",
			dataIndex: "p_price",
			width: 120
		},
		{
			title: "数量",
			key: "num",
			dataIndex: "num",
			width: 100
		},
		{
			title: "订单号",
			key: "sNo",
			dataIndex: "sNo",
			width: 200
		},
		// {
		//   title: "订单状态",
		//   dataIndex: "status",
		//   width: 100,
		//
		// },
		{
			title: "实退金额",
			key: "real_money",
			dataIndex: "real_money",
			width: 120
		},
		{
			title: "申请时间",
			key: "re_time",
			dataIndex: "re_time",
			width: 170
		},
		{
			title: "类型",
			key: "tab_nowrap",
			dataIndex: "tab_nowrap",
			scopedSlots: {
				customRender: "tabNowrap"
			},
			width: 120
		},
		{
			title: "状态",
			key: "re_type",
			dataIndex: "re_type",
			scopedSlots: {
				customRender: "reType"
			},
			width: 120
		},
		{
			title: "操作",
			key: "action",
			scopedSlots: {
				customRender: "action"
			},
			width: 120,
			fixed: 'right'
		},
	];

	const columns = [
		//  {
		//    title: "订单编号",
		// key: "sNo",
		//    dataIndex: "sNo",
		//    width: 200,
		//  },

		{
			title: "订单信息",
			key: "goods_info",
			dataIndex: "goods_info",
			width: 400,
			scopedSlots: {
				customRender: "goods_info"
			},
		},
		{
			title: "订单总计",
			key: "z_price",
			width: 120,
			scopedSlots: {
				customRender: "z_price"
			},
		},
		{
			title: "数量",
			dataIndex: "num",
			width: 100,
		},
		{
			title: "下单类型",
			key: "operation_type",
			width: 120,
			scopedSlots: {
				customRender: "operation_type"
			},
		},
		{
			title: "订单状态",
			dataIndex: "status",
			width: 100,
			scopedSlots: {
				customRender: "status"
			},
		},
		{
			title: "订单类型",
			dataIndex: "otype_name",
			width: 100,
			scopedSlots: {
				customRender: "order_type"
			},
		},
		{
			title: "运输方式",
			width: 100,
			scopedSlots: {
				customRender: "self_lifting"
			},
		},
		{
			title: "买家信息",
			dataIndex: "buyer_info",
			width: 220,
			scopedSlots: {
				customRender: "buyer_info"
			},
		},
		{
			title: "支付方式",
			dataIndex: "pay",
			width: 130,
		},
		{
			title: "物流信息",
			dataIndex: "logistics_info",
			width: 320,
			scopedSlots: {
				customRender: "logistics_info"
			},
		},
		// {
		//   title: "创单时间",
		//   dataIndex: "add_time",
		//   width: 170,
		// },
		{
			title: "操作",
			key: "action",
			width: 110,
			fixed: 'right',
			scopedSlots: {
				customRender: "action"
			},
		},
	];

	export default {
		data() {
			return {
				tableHeight: 0,
				pagination: {},
				rowSelection: {
					onChange: (selectedRowKeys, selectedRows) => {
						this.selectedRowKeys = selectedRowKeys;
						console.log(
							`selectedRowKeys: ${selectedRowKeys}`,
							"selectedRows: ",
							selectedRows
						);
					},
					onSelect: (record, selected, selectedRows) => {
						console.log(record, selected, selectedRows);
					},
					onSelectAll: (selected, selectedRows, changeRows) => {
						console.log(selected, selectedRows, changeRows);
					},
				},
				selectedRowKeys: [],
				columnsA,
				urls: "",
				columns: columns,
				visible1: false, // 导出
				visible: false, // 物流信息
				modelbatch: false, // 批量发货
				file: "",
				deliverLoading: false,
				expressList: [],
				filepath: "",
				tableScroll: {},
				form: this.$form.createForm(this, {
					name: "deliver"
				}), // 搜索form
				form2: this.$form.createForm(this, {
					name: "searchform"
				}), // 批量发货form
				form3: this.$form.createForm(this, {
					name: "returnform"
				}), // 回寄商品form
				searchfrom: {
					sNo: "",
				},
				orderlist: [],
				config: {
					total: 0,
					load: true,
				},
				ordertype: [],
				orderstate: [], // 订单状态
				param: {}, // 搜索内容
				tabs: "", // tab当前位置
				logisticslist: [], // 物流地址
				page_new: 1,

				returnVisible: false,
				kuaidi_name: "",
				kuaidi_sNo: "",
				kuaidi_list: [],

				jujueFlag: false,
				jujueForm: this.$form.createForm(this, {
					name: "jujueForm"
				}), // 回寄商品form
				clickOrderItem: {},

				hexiaoFlag: false,
				hexiaoForm: this.$form.createForm(this, {
					name: "hexiaoForm"
				}), // 回寄商品form
				hexiaoId: ''
			};
		},
		computed: {
			order_type() {
				return (item) => {
					switch (item.otype) {
						case "pt":
							return "拼团订单";
							break;
						case "PP":
							return "拼团订单";
							break;
						case "JP":
							return "竞拍订单";
							break;
						case "KJ":
							return "砍价订单";
							break;
						case "IN":
							return "积分订单";
							break;
						case "MS":
							return "秒杀订单";
							break;
						case "PM":
							return "秒杀订单";
							break;
						default:
							if (item.drawid > 0) {
								return "抽奖订单";
							}
							return "正价订单";
							break;
					}
				};
			},
		},
		created() {
			console.log(this.$route);
			if (this.$route.query.hasOwnProperty("tabs")) {
				this.tabs = this.$route.query.tabs;
			}
		},
		mounted() {
			this.getOrderList();
			this.initOrder();

			this.$nextTick(() => {

			})
		},
		methods: {
			onBatchPrint() {
				let sNo = this.selectedRowKeys.join(',')
				if (!sNo) {
					this.$message.warning('请选择需要打印的订单')
					return false;
				}

				let token = sessionStorage.getItem('token')
				let url = encodeURIComponent(process.env.VUE_APP_BASE_URL)
				let openUrl = ''
				if (process.env.VUE_APP_NODE_ENV === 'dev') {
					openUrl = window.location.origin + `/print.html?url=${url}&token=${token}&sNo=${sNo}`
				} else {
					openUrl = window.location.origin + process.env.VUE_APP_PUBLIC_PATH +
						`print.html?url=${url}&token=${token}&sNo=${sNo}`
				}
				const newWin = window.open(openUrl, "_blank")
				newWin.onload = function () {

				}
			},
			getTableHeight() {
				setTimeout(() => {
					if (this.tableHeight == 0) {
						if (document.getElementById('tableHeight')) {
							this.tableHeight = document.getElementById('tableHeight').clientHeight - 120
						}
						console.log(this.tableHeight)
						if (this.tableHeight <= 0) {
							this.tableHeight = 900
						}

						this.tableScroll = {
							x: 1880,
							y: this.tableHeight
						}
					}
				}, 100)
			},
			/**
			 * @name 关闭订单
			 */
			onOrderClose(sNo) {
				this.$confirm({
					title: '提示',
					content: '确定关闭此订单?',
					onOk: () => {
						this.$request.post('?module=pc_api&action=order&m=close_return', {
							oid: sNo
						}).then(res => {
							let {
								code,
								message
							} = res

							if (code == 200) {

								this.$message.success('关闭订单成功')
								this.getOrderList()
								setTimeout(() => {
									this.$emit('loads')
								}, 600)

							} else {
								this.$message.warning(message)

								setTimeout(() => {
									this.$emit('loads')
								}, 600)
							}
						})
					}
				})

			},
			/**
			 * @name 删除订单
			 */
			onDeleteOrder(item) {
				let {
					sNo
				} = item;
				this.$confirm({
					title: "提示",
					content: "确定删除此订单?",
					onOk: () => {
						this.$request
							.get("?module=pc_api&action=order&m=del", {
								params: {
									data: sNo
								}
							})
							.then((res) => {
								let {
									code,
									message
								} = res;
								if (code == 200) {
									this.$message.success("删除成功");

									setTimeout(() => {
										this.getOrderList();
									}, 600);
								} else {
									this.$message.warning(message);

									setTimeout(() => {
										this.getOrderList();
									}, 600);
								}
							});
					},
				});
			},
			/**
			 * @name 初始化
			 */
			initOrder() {
				this.$request
					.get("?module=pc_api&action=order&m=index", {
						params: {
							page: 1
						}
					})
					.then((res) => {
						let {
							code,
							message,
							data
						} = res;
						if (code === 200) {
							Object.assign(this, {
								orderstate: data.class,
								ordertype: data.ordtype,
								config: {
									total: Number(data.total),
									load: false,
								},
							});
							this.getTableHeight();
						} else {
							this.$message.error(message);
						}
					});
			},
			/**
			 * @name 查看详情
			 * @return { }
			 * */

			onViewDetails(id) {
				this.$router.push({
					path: "ordermanage/details/" + id
				});
			},
			saveKuaidi() {
				this.form3.validateFields((err, values) => {
					if (!err) {
						var data = {
							sNo: this.clickOrderItem.r_sNo,
							id: this.clickOrderItem.id,
							express: values.kuaidi_name, // 快递ID
							courier_num: values.kuaidi_sNo, // 快递单号
							r_type: 11,
						};
						this.$request
							.post("?module=pc_api&action=ReturnGoods&m=examine", data)
							.then((res) => {
								if (res.code == 200) {
									this.$message.success("发货成功！");
								} else {
									this.$message.error("发货失败请稍后再试！");
								}
								this.getOrderList();
								this.kuaidi_list = res.list;
								// 请求完后清空数据并隐藏弹窗
								this.returnVisible = false;
								this.form3.resetFields();
							});
					}
				});
			},
			/*
			选择快递公司
		 */
			handleChange(value) {
				this.kuaidi_id = value;
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text
					.toLowerCase()
					.indexOf(input.toLowerCase()) >= 0
				);
			},
			openHexiao(id) {
				this.hexiaoId = id;
				this.hexiaoFlag = true;
				this.hexiaoForm.resetFields();
			},
			hexiaoOk() {
				this.hexiaoForm.validateFields((err, values) => {
					if (!err) {
						let data = {
							order_id: this.hexiaoId,
							extraction_code: values.hexiao
						}
						this.$request
							.post("?module=pc_api&action=order&app=verification_extraction_code", data)
							.then((res) => {
								this.hexiaoFlag = false;
								if (res.code == 200) {
									this.getOrderList();
									this.$message.success(res.message);
								} else {
									this.$message.error(res.message);
								}
							});
					}
				});
			},
			// 拒绝理由
			onGoBack() {
				this.jujueForm.validateFields((err, values) => {
					if (!err) {
						var data = {
							sNo: this.clickOrderItem.sNo,
							id: this.clickOrderItem.id,
							text: values.text,
							r_type: 5,
						};
						if (
							this.clickOrderItem.re_type == 3 &&
							this.clickOrderItem.r_type == 3
						) {
							data.r_type = 5;
						}
						this.$request
							.post("?module=pc_api&action=ReturnGoods&m=examine", data)
							.then((res) => {
								this.jujueFlag = false;
								if (res.code == 200) {
									this.getOrderList();
									this.$message.success("拒绝成功！");
								} else {
									this.$message.error("拒绝失败！");
								}
							});
					}
				});
			},
			returnBtn(type, id, record) {
				if (type == 1) {
					this.$router.push({
						path: "ordermanage/audit/" + id
					});
				} else if (type == 2) {
					// 同意退款
					this.$confirm({
						title: "提示",
						content: `确认同意退款，金额为${record.re_money}`,
						onOk: () => {
							var data = {
								sNo: record.sNo,
								id: id,
								price: record.re_money,
								r_type: 9,
							};
							if (record.re_type == 1 && record.r_type == 3) {
								data.r_type = 4;
							}
							this.$request
								.post("?module=pc_api&action=ReturnGoods&m=examine", data)
								.then((res) => {
									if (res.code == 200) {
										this.getOrderList();
										this.$message.success("退款成功！");
									} else {
										this.$message.error("退款失败！");
									}
								});
						},
					});
				} else if (type == 3) {
					// 获取快递公司名称的接口
					this.$request
						.post("?module=pc_api&action=ReturnGoods&m=into_send", {
							page: 1
						})
						.then((res) => {
							this.kuaidi_list = res.list;

							this.clickOrderItem = record;

							this.returnVisible = true;
						});
				} else if (type == 4) {
					// 拒绝退款或换货
					this.clickOrderItem = record;
					this.jujueFlag = true;
				} else if (type == 5) {
					this.$router.push({
						path: "ordermanage/see/" + id
					});
				}
			},
			onChangess(pagination) {
				this.getOrderList({
					...pagination,
					page: pagination.current
				});
			},
			getTabNowrap(record) {
				if (record.re_type == 2) {
					return "仅退款";
				} else if (record.re_type == 1) {
					return "退货退款";
				} else {
					return "换货";
				}
			},
			getReType(record) {
				if (record.re_type == 1 || record.re_type == 2) {
					if (record.r_type == 0 && record.r_type != "") {
						return "待审核";
					} else if (record.r_type == 1 || record.r_type == 3) {
						return "退款中";
					} else if (record.r_type == 11) {
						return "退款成功";
					} else if (record.r_type == 5) {
						return "退款失败";
					} else if (
						record.r_type == 4 ||
						record.r_type == 9 ||
						record.r_type == 12
					) {
						return "退款成功";
					} else if (record.r_type == 2 || record.r_type == 8) {
						return "退款失败";
					} else if (record.r_type == 10) {
						return "退款失败";
					}
				} else if (record.re_type == 3) {
					if (record.r_type == 0 && record.r_type != "") {
						return "待审核";
					} else if (
						record.r_type == 1 ||
						record.r_type == 3 ||
						record.r_type == 11
					) {
						return "换货中";
					} else if (record.r_type == 5) {
						return "换货失败";
					} else if (
						record.r_type == 4 ||
						record.r_type == 9 ||
						record.r_type == 12
					) {
						return "换货成功";
					} else if (record.r_type == 2 || record.r_type == 8) {
						return "换货失败";
					} else if (record.r_type == 10) {
						return "换货失败";
					}
				}
			},
			/**
			 * @name 切换面板的回调
			 */
			onTabsCallback(activeKey) {
				this.handleReset();
				this.tabs = activeKey;

				this.param = {};

				this.$router.push({
					path: this.$route.path,
					query: Object.assign({}, this.$route.query, {
						tabs: activeKey
					}),
				});

				this.getOrderList();
			},
			/**
			 * @name 获取订单列表
			 */
			getOrderList(padds = {}) {
				this.config.load = true;
				this.orderlist = [];
				let url = "?module=pc_api&action=order&m=index";

				if (!padds.page) {
					padds.page = this.pagination.page
				}

				let page = padds;

				let param = {
					...this.param,
				};

				if (this.tabs !== "") {
					param.status = this.tabs;
				}

				if (this.tabs == 4) {
					url = "?module=pc_api&action=order&m=return_list";

				}
				this.$request.get(url, {
					params: {
						...param,
						...page
					}
				}).then((res) => {
					let {
						code,
						message,
						data
					} = res;
					if (code === 200) {
						if (this.tabs == 4) {
							Object.assign(this, {
								orderlist: data.list,
								total: Number(data.total),
								pagination: {
									total: Number(data.total),
									page: padds.page ? padds.page : 1,
									current: padds.current ? padds.current : 1,
								},
								config: {
									total: Number(data.total),
									load: false,
								},
							});
							this.getTableHeight();
							return;
						}

						Object.assign(this, {
							orderlist: data.order,
							total: Number(data.total),
							pagination: {
								total: Number(data.total),
								page: padds.page ? padds.page : 1,
								current: padds.current ? padds.current : 1,
							},
							config: {
								total: Number(data.total),
								load: false,
							},
						});
						this.getTableHeight();
					} else {
						this.$message.error(message);
					}
				});
			},
			/**
			 * @name 表格查看物流回调
			 * */

			onOpenDodal(item) {
				this.visible = !this.visible;
				this.httpGetLogistics(item.sNo);
			},
			httpGetLogistics(sNo) {
				this.$request
					.get("?module=pc_api&action=order&app=kuaidishow", {
						params: {
							r_sNo: sNo
						},
					})
					.then((res) => {
						let {
							code,
							list
						} = res;
						if (code == 200) {
							let logisticslist = [];
							list.filter((item) => {
								if (item.kuaidi_name) {
									logisticslist.push(item);
								}
							});
							this.logisticslist = logisticslist;
						}
					});
			},
			/**
			 * @name 运费设置
			 * */

			onConfig() {
				this.$router.push({
					path: "ordermanage/config"
				});
			},
			/**
			 * @name 批量发货
			 * @description 使用form提交
			 */
			onDeliver(e) {
				e.preventDefault();

				this.form.validateFields((err, values) => {
					if (!err) {
						this.deliverLoading = true;
						let formData = new FormData();

						formData.append("file", this.file);
						formData.append("express_id", values.express_id);

						let config = {
							headers: {
								"Content-Type": "multipart/form-data",
							},
						};

						this.$request
							.post(
								"?module=pc_api&action=Phpexcel&m=up_list&get_moban=0",
								formData,
								config
							)
							.then((res) => {
								let {
									code,
									message,
									data
								} = res;

								if (code === 200) {
									this.$message.success(message);
									setTimeout(() => {
										this.deliverLoading = false;
										this.modelbatch = !this.modelbatch;
									}, 700);
								} else {
									this.$message.warning(message);
									this.deliverLoading = false;
								}
							})
							.catch((err) => {
								this.$message.error("接口访问错误，请联系管理员！");
								setTimeout(() => {
									this.deliverLoading = false;
								}, 700);
							});
					}
				});
			},
			/**
			 * @name 打开批量发货
			 */
			onOpenDeliver() {
				this.getExpressList();
				this.modelbatch = !this.modelbatch;
			},
			/**
			 * @name 选择文件
			 * */

			onGetFile(event) {
				this.file = event.target.files[0];
				this.filepath = this.file.name;
			},
			/**
			 * @name 获取快递公司列表
			 * */

			getExpressList() {
				this.$request
					.get("?module=pc_api&action=Phpexcel&m=get_express&store_id=1")
					.then((res) => {
						let {
							code,
							message,
							data
						} = res;

						if (code === 200) {
							this.expressList = data;
						}
					});
			},
			/**
			 * @name 导出
			 * */

			download() {
				var url;
				if (this.tabs == 4) {
					//退款
					url = "?module=pc_api&action=order&m=return_list&pageto=";
				} else {
					url = "?module=pc_api&action=order&m=index&pageto=";
				}
				// let result = this.$refs[refnamm].getPitchlist()

				// if(result.length){
				//   this.$request.BandParamDownload('?module=pc_api&action=Phpexcel&m=down_list&get_moban=0',{ id: result })
				//   return
				// }

				// this.$message.warning('请选择需要导出的订单！')
				this.urls = url;
				this.visible1 = !this.visible1;
			},
			/**
			 * @name 点击遮罩层或右上角叉或取消按钮的回调
			 * */

			closeDeliver() {
				this.deliverLoading = false;
				this.filepath = "";
				this.form.resetFields();
			},
			/**
			 * @name 模版下载
			 * */

			templateDownload() {
				let result = this.$refs["alltable"].getPitchlist();

				if (result.length) {
					this.$request.BandParamDownload(
						"?module=pc_api&action=Phpexcel&m=down_list&get_moban=0", {
							id: result
						}
					);
					return;
				}
				this.$message.warning("请选择需要发货的订单！");
			},
			/**
			 * @name 搜索重置
			 * */

			handleReset() {
				this.form2.resetFields();
			},
			/**
			 * @name 搜索
			 */
			handleSubmit(e) {
				e.preventDefault();
				this.form2.validateFields((err, values) => {
					if (!err) {
						this.page_new = 0;
						setTimeout(() => {
							this.page_new = 1;
						}, 10);
						let startdate, enddate;

						if (values.date && values.date.length) {
							startdate = values.date[0].format("YYYY-MM-DD");
							enddate = values.date[1].format("YYYY-MM-DD");
						} else {
							startdate = "";
							enddate = "";
						}

						let sNo = values.sNo || "";
						let status = values.status || "";
						let otype = values.otype || "";
						let r_type = values.r_type || "";

						this.param = {
							startdate,
							enddate,
							sNo,
							status,
							otype,
							r_type
						};
						this.pagination.page = 1;
						this.getOrderList();
					}
				});
			},
			/**
			 * @name 分页回调事件
			 */
			monitorPaging() {
				this.getOrderList();
			},
			/**
			 * @name 批量删除
			 */
			onBatchDel() {
				if (!this.selectedRowKeys) {
					this.$message.warning("请选择需删除的订单！");
					return;
				}

				this.$confirm({
					title: "提示",
					content: "确定要删除所选订单吗?",
					onOk: () => {
						this.httpDel(this.selectedRowKeys.join(','));
					},
				});
			},
			/**
			 * @name 删除订单
			 */
			httpDel(strId) {
				this.$request
					.get("?module=pc_api&action=order&m=del", {
						params: {
							data: strId
						}
					})
					.then((res) => {
						let {
							code,
							message
						} = res;
						if (code == 200) {
							this.$message.success("批量删除成功");

							setTimeout(() => {
								this.getOrderList();
							}, 600);
						} else {
							this.$message.warning(message);

							setTimeout(() => {
								this.getOrderList();
							}, 600);
						}
					});
			},
			/**
			 * @name 导出
			 */
			onDownload(pageto) {
				if (pageto != "whole") {
					this.form2.validateFields((err, values) => {
						if (!err) {
							let startdate;
							let enddate;

							let {
								mobile,
								date
							} = values;
							if (date) {
								// 开始时间
								startdate = date[0].format("YYYY-MM-DD HH:mm:ss");
								// 结束时间
								enddate = date[1].format("YYYY-MM-DD HH:mm:ss");
							}
							let data = {
								startdate,
								enddate,
								...values,
								status: this.tabs
							};

							data.page = this.pagination.page;
							console.log(this.urls);
							this.$request.download(this.urls + pageto, data);
						}
					});
					return;
				}

				if (this.status == "") {
					var expUrl =
						this.exportURL +
						this.urls +
						pageto +
						"&page=" +
						this.pagination.page;
				} else {
					var expUrl =
						this.exportURL +
						this.urls +
						pageto +
						"&page=" +
						this.pagination.page +
						"&status=" +
						this.tabs;
				}

				this.$request.download(expUrl);
			},
		},
		components: {
			OrderTable,
		},
	};
</script>
<style lang="less">
	.orderBox[class] {
		td {
			position: relative;
			padding: 53px 16px 20px;

			.ant-checkbox-wrapper {
				position: absolute;
				top: 16px;
				left: 23px;
			}

			.order_sNo {
				position: absolute;
				left: 16px;
				top: 20px;
				font-size: 14px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #969DA8;
				line-height: 14px;
				z-index: 9;

				span {
					margin: 0 20px;
				}
			}
		}

	}

	.fund_manage {
		display: flex;
		flex-direction: column;
		height: 100%;

		.ant-tabs {
			display: flex;
			flex-direction: column;
			height: 100%;

			.ant-tabs-content {
				flex: 1;
			}

			.ant-tabs-top-content>.ant-tabs-tabpane,
			.ant-tabs-bottom-content>.ant-tabs-tabpane {
				display: flex;
				flex-direction: column;
			}
		}

		.search {
			padding: 8px 32px;
		}

		.handle {
			padding: 0px 32px;
			padding-bottom: 8px;
			display: flex;
			align-items: center;
		}

		#tableHeight {
			flex: 1;
		}
	}

	.logistics {
		height: 600px;
		overflow: overlay;

		&-box {
			display: flex;

			&-right {
				padding-top: 6px;
			}
		}
	}

	.times {
		font-size: 14px;
		font-weight: 400;
		color: #969da8;
	}

	.templatepush {
		display: flex;
		align-items: baseline;
	}

	input[type="file"] {
		width: 72px;
		background: #e9ecef;
		outline: none;
		-webkit-appearance: button;
		-webkit-appearance: none;
		border-radius: 0;
	}

	.freight {
		margin-right: 20px;
	}

	.derive {
		height: 200px;
		display: flex;
		justify-content: space-around;
		align-items: center;

		>div {
			width: 100px;
			height: 100px;
			border: 1px solid #03a2f4;
			border-radius: 4px;
			color: #03a2f4;
			font-size: 14px;
			transition: background-color 0.5s;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-evenly;
			cursor: pointer;
		}

		>div:hover {
			border: 0px solid #03a2f4;
			color: #ffffff;
			background: #2890ff;
		}
	}

	.yuanquan {
		width: 16px;
		height: 16px;
		display: flex;
		border: 1px solid #ea4235;
		color: #ea4235;
		align-items: center;
		justify-content: center;
		border-radius: 999em;
		margin-right: 6px;
	}

	.goods_info {
		display: flex;
		height: 90px;

		img {
			width: 90px;
			height: 90px;
			background: rgba(255, 255, 255, 1);
			border: 1px solid rgba(233, 236, 239, 1);
			margin-right: 10px;
		}

		&_right {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}
	}

	.buyer_info {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.logistics_info {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.ant-table td {
		white-space: nowrap;
	}

	.ant-tabs .ant-tabs-top-content>.ant-tabs-tabpane,
	.ant-tabs .ant-tabs-bottom-content>.ant-tabs-tabpane {
		display: flex;
		flex-direction: column;
	}

	.bold {
		font-weight: bold;
	}
</style>